export default "__VITE_ASSET__49dd5507__"